if (!window.apB2bContextBound) {
  window.apB2bContextBound = true;
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const trigger = event.target.closest('a[data-ap-solution]');
    if (!trigger) return;
    const form = trigger.closest('.ap-page')?.querySelector('form.ap-form');
    const select = form?.querySelector('select[data-ap-interest]');
    if (!select) return;
    const aliases = { delonghi_magnifica: 'grao_automatica', tasting: 'proposal' };
    const code = aliases[trigger.dataset.apSolution] || trigger.dataset.apSolution;
    const option = Array.from(select.options).find((item) => item.dataset.apInterestCode === code);
    if (!option) return;
    select.value = option.value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  });
}
